import { useCallback } from 'react'
import { useTranslate } from 'react-admin'

export const useTranslateFromRelativeKey = (prefix: string) => {
  const translate = useTranslate()
  return useCallback((key: string) => translate(`${prefix}.${key}`), [translate, prefix])
}
